import { Inquiry } from "@robe/core-types/inquiry";
import { BaseApiRequest, handleXcoreError } from "@robe/core-api";
import { XcoreCore } from "XcoreCore";
import { InsertInquiryError } from "../errors/InsertInquiryError";
import { parseQueryParamsObject } from "@robe/core-utils";
import { baseWebFetchOptions } from "../web/options";

export interface InsertInquiryParams {
  contentIds: number[];
  region: string;
  locale: string;
}

/**
 * @throws {InsertInquiryError}
 */
export const insertInquiry = (core: XcoreCore, { locale, ...params }: InsertInquiryParams): BaseApiRequest<Inquiry> =>
  core
    .fetch(`/api/inquiry${parseQueryParamsObject({ locale })}`, {
      method: "POST",
      ...baseWebFetchOptions,
      body: JSON.stringify(params),
    })
    .then<Inquiry>((res, url) => (res.ok ? res.json() : handleInsertInquiryError(url, res)));

export const handleInsertInquiryError = handleXcoreError((...args) => new InsertInquiryError(...args));
